import React, { forwardRef } from "react";
import { Box, Button, Slide } from "@mui/material";

import styles from "./Resultado.module.css";
import Theme from "../../../constants/Theme";
import {
  RESTART_PROCESS,
  useStepsContext,
} from "../../../contexts/steps-controller";

const Resultado = forwardRef(function Resultado(
  { setHeight, fadeInRight, fadeOutLeft, setIsActive, hidden, ...props },
  ref
) {
  const { formStepsState, formStepsController } = useStepsContext();

  return (
    <div hidden={hidden}>
      <Slide direction="left" in={!hidden} timeout={200}>
        <Box
          ref={ref}
          sx={{
            display: "flex",
            flexDirection: "column",
          }}
        >
          <h1 className={styles.title}>
            ¡El proceso de facturación está listo!
          </h1>
          <Box
            className={styles.exportOptionsContainer}
            sx={{
              display: "flex",
              justifyContent: "center",
              flexWrap: "wrap",
            }}
          >
            <lottie-player
              src="https://assets10.lottiefiles.com/packages/lf20_6oomsuir.json"
              mode="bounce"
              background="rgba(255, 255, 255, 0)"
              speed="1"
              style={{ width: 250, height: 200 }}
              autoplay
              loop
            ></lottie-player>
            <Box
              className={styles.containerInstructions}
              style={{ display: "flex", flexDirection: "column" }}
            >
              <p className={styles.instructions}>
                El proceso de facturación se ha completado, la factura llegará
                al correo <b>{formStepsState.emailStep.email}</b> dentro de las
                siguientes 24 horas. No olvides checar tu carpeta de spam
              </p>
              <Button
                variant="contained"
                className={styles.restartButton}
                onClick={() => {
                  formStepsController({ type: RESTART_PROCESS });
                  setIsActive(1);
                }}
                style={{
                  backgroundColor: Theme.COLORS.PRIMARY,
                  fontFamily: 'Montserrat, Arial, sans-serif'
                }}
              >
                Generar otra factura
              </Button>
            </Box>
          </Box>
          <Box
            // className={styles.container}
            sx={{
              display: "flex",
              flexDirection: "column",
            }}
          ></Box>
          <p className={styles.plumaNegra}>
            This app was &#60;&#47;&#62; with ❤️ by Pluma Negra
          </p>
        </Box>
      </Slide>
    </div>
  );
});

export default Resultado;
